import React from 'react';
import { useIsCrossProjectViewsEnabled } from '@atlassian/jira-polaris-lib-entitlement-utils/src/index.tsx';
import type PolarisCollectionsPageType from '@atlassian/jira-spa-apps-polaris-collections/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { Redirect } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyCollectionsPage = lazyForPaint<typeof PolarisCollectionsPageType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-polaris-collections", jiraSpaEntry: "async-polaris-collections" */ '@atlassian/jira-spa-apps-polaris-collections'
			),
		),
	{ ssr: false },
);

const useJpdLicensed = () => {
	const context = useTenantContext();
	return context.licensedProducts['jira-product-discovery'];
};

export const RedirectingCollectionsPage = (): React.JSX.Element => {
	const jpdLicensed = useJpdLicensed();
	const crossProjectViewsEnabled = useIsCrossProjectViewsEnabled();

	if (!jpdLicensed) {
		return <Redirect to="/jira/polaris/unlicensed" />;
	}

	if (!crossProjectViewsEnabled) {
		return <Redirect to="/jira" />;
	}

	return (
		<LazyPage
			Page={LazyCollectionsPage}
			pageId="async-polaris-collections"
			shouldShowSpinner={false}
		/>
	);
};

export default RedirectingCollectionsPage;
